import { render, staticRenderFns } from "./import-module.vue?vue&type=template&id=224e3416&scoped=true&"
import script from "./import-module.vue?vue&type=script&lang=ts&"
export * from "./import-module.vue?vue&type=script&lang=ts&"
import style0 from "./import-module.vue?vue&type=style&index=0&id=224e3416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224e3416",
  null
  
)

export default component.exports